import type { LeadsSearchColumnListConfig } from "app/pages/sales-intelligence/modules/leads-search";

import { createLeadsSearchColumnList } from "./columnList";

let _leadsSearchColumnListConfig: LeadsSearchColumnListConfig | null = null;

export const getLeadsSearchColumnListConfig = (): LeadsSearchColumnListConfig => {
    if (!_leadsSearchColumnListConfig) {
        _leadsSearchColumnListConfig = createLeadsSearchColumnList();
    }
    return _leadsSearchColumnListConfig;
};
